<i [ngStyle]="{ transform: transformValue }" class="d-inline-block {{ getIcon() }}"></i>
